import { useCallback } from 'react';

import { useNavigate } from 'react-router';

import { Button, Flex, Image, Menu, MenuButton, MenuItem, MenuList, Spacer, Text } from '@chakra-ui/react';

import { isDefined } from '@enterprise/core';
import { CircleUser, RightFromBracket } from '@enterprise/ui';

import { LOGOUT_URI } from '@/common/constants/config';
import { NotificationBell } from '@feat/notifications/components/notification-bell/notification-bell';
import { useApplicationStore } from '@hooks/application/application-store.hook';

const TopBar = () => {
  const navigate = useNavigate();
  const user = useApplicationStore(({ user }) => {
    return user;
  });

  const onLogout = useCallback(() => {
    const returnTo = window.location.pathname + window.location.search;
    const returnUrl = new URL('/logout', window.location.origin);

    returnUrl.searchParams.set('returnTo', returnTo);

    const params = new URLSearchParams({ returnUrl: returnUrl.toString() });

    location.assign(`${LOGOUT_URI}?${params.toString()}`);
  }, []);

  return (
    <Flex
      align="center"
      bg="white"
      p={2}
      w="full">
      <Image
        alt="HSP Direct"
        boxSize="48px"
        src="/images/hsp_logo_180x142.png"
      />
      <Spacer />
      <Flex gap={3}>
        <NotificationBell />
        <Menu isLazy>
          <MenuButton
            _hover={{ cursor: 'pointer', textDecoration: 'none' }}
            as={Button}
            colorScheme="hsp"
            leftIcon={
              <CircleUser
                size="2xl"
                widthAuto
              />
            }
            variant="link">
            {isDefined(user) && (
              <Flex
                align="start"
                color="hsp.500"
                flexDirection="column">
                <Text fontSize="md">{user.fullName}</Text>
                <Text fontSize="sm">{user.emailAddress}</Text>
              </Flex>
            )}
          </MenuButton>
          <MenuList>
            <MenuItem
              icon={
                <CircleUser
                  size="xl"
                  widthAuto
                />
              }
              onClick={() => {
                return navigate('/datastream/profile');
              }}>
              My Profile
            </MenuItem>
            <MenuItem
              icon={
                <RightFromBracket
                  size="xl"
                  widthAuto
                />
              }
              onClick={onLogout}>
              Log out
            </MenuItem>
          </MenuList>
        </Menu>
      </Flex>
    </Flex>
  );
};

export default TopBar;
